import { Weekdays } from 'modules/core/lib/firstDayOfWeek'
import { Model } from 'modules/core/lib/mobx-rest'

interface IDayConfiguration {
  id: string
  weekday: Weekdays
  start_at: string
  end_at: string
  duration_in_seconds: number
  overlap_period_id: string
}

class DayConfiguration extends Model<IDayConfiguration> {
  static urlRoot() {
    return '/work_schedule/day_configurations'
  }
}

export default DayConfiguration
